import React from "react";
import styles from "./Banner.module.css";
import cn from "classnames";
import { IconButton } from "src/components/ui-components/Button/IconButton";
import { IconCross } from "src/components/ui-components/Icons/IconCross";
import { withNoSSR } from "src/components/ui-components/withNoSSR/withNoSSR";

export const BannerCTAs: React.FC<{ children: React.ReactNode }> = (props) => {
  return <div className={styles.ctas}>{props.children}</div>;
};

type Color =
  | "success"
  | "warning"
  | "error"
  | "info"
  | "neutral"
  | "brand-orange"
  | "brand-blue";

interface BannerProps {
  color?: Color;
  dismissable?: boolean;
  onDismiss?: () => void;
  children: React.ReactNode;
}

export const Banner = withNoSSR<BannerProps>(function Banner(props) {
  const {
    dismissable = false,
    onDismiss = () => {},
    color = "brand-blue",
  } = props;

  return (
    <div className={cn(styles.banner, styles[`color--${color}`])}>
      {props.children}
      {dismissable && (
        <IconButton
          theme="ghost"
          size="XS"
          className={styles.dismiss}
          onClick={onDismiss}
        >
          <IconCross />
        </IconButton>
      )}
    </div>
  );
});
